import React from "react";
import { useCaseFeedbackGuidanceMessages } from "./use_case_feedback_guidance_messages";
import { FlexibleTestingTestCaseFeedback, Maybe } from "types/graphql";
import {
  getUniqueFeedbackCodes,
  generateTitlesFromFeedback,
  generateMessagesFromFeedback,
  formatMessages,
} from "./helpers";

type CaseFeedbackProps = {
  feedback: Maybe<Array<FlexibleTestingTestCaseFeedback>> | undefined;
};

const CaseFeedback = ({ feedback }: CaseFeedbackProps) => {
  const { caseFeedbackGuidanceMessages } = useCaseFeedbackGuidanceMessages();
  const uniqueFeedback = getUniqueFeedbackCodes(feedback);
  const titles = generateTitlesFromFeedback(uniqueFeedback, caseFeedbackGuidanceMessages).map(title => (
    <div className="font-bold">
      💬 <span className="ml-sm">{title}</span>
    </div>
  ));
  const messages = generateMessagesFromFeedback(uniqueFeedback, caseFeedbackGuidanceMessages);

  return (
    <div className="mb-3xl -mt-3xl">
      <div className="mb-xs">{titles}</div>
      <div className="max-w-md text-secondary ml-3xl">
        To get the best results out of test case runs it is important that
        {formatMessages(messages)}. Consider updating this test case to get better results on future test case runs.
      </div>
    </div>
  );
};

export default CaseFeedback;
